import DeleteRoleModal from './DeleteRoleModal.vue';

export default DeleteRoleModal;
